import { render } from "./AvatarFileInput.vue?vue&type=template&id=a01d1b58&scoped=true"
import script from "./AvatarFileInput.vue?vue&type=script&lang=js"
export * from "./AvatarFileInput.vue?vue&type=script&lang=js"

import "./AvatarFileInput.vue?vue&type=style&index=0&id=a01d1b58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a01d1b58"]])

export default __exports__